import { AppState, createAppContext } from "o4a-react";

export interface ConsoleState extends AppState {
  isCanarySession?: boolean;
}

export const ConsoleContext = createAppContext<ConsoleState>({} as ConsoleState);
export const ConsoleContextProvider = ConsoleContext.Provider;
